<div class="toolbar">
  <button class="dialogButton" matButton="text" [disabled]="isBusy()" (click)="goBack()">
    <span>
      <mat-icon class="size-16">cancel</mat-icon>
      <label class="buttonLabel">Cancel</label>
    </span>
  </button>
  <button class="dialogButton primary-button" matButton="text" [disabled]="!canSave()" (click)="save()">
    <span>
      <mat-icon class="size-16">save</mat-icon>
      <label class="buttonLabel">{{ saveButtonText() }}</label>
    </span>
  </button>
</div>
@if (errorMessage()) {
  <div class="errorMessage">
    {{ errorMessage() }}
  </div>
}
@if (dataLoaded()) {
  <div>
    <app-ratings-tool-form [unitToUpdate]="unitToUpdate()" [schedule]="schedule()" [scheduleLine]="scheduleLine()"
      (unitToUpdateChange)="updatedUnit = $event" (tagsUpdated)="updateTags($event)">
    </app-ratings-tool-form>
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait</label>
    </div>
  </div>
}
